import { render, staticRenderFns } from "./SettingsAlign.vue?vue&type=template&id=03c2bb02&scoped=true&"
import script from "./SettingsAlign.vue?vue&type=script&lang=js&"
export * from "./SettingsAlign.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAlign.vue?vue&type=style&index=0&id=03c2bb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2bb02",
  null
  
)

export default component.exports